// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1DhM6","inner":"Form_inner__39z7w","range":"Form_range__1p3VI","name":"Form_name__-3SEB","actions":"Form_actions__RvGqr"};